function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useTimeout } from '@bydesign-ui/hooks';
import React from 'react';
export function RcNotification(props) {
  var onClose = props.onClose,
      options = props.options,
      space = props.space,
      Component = props.Component,
      position = props.position,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? 0 : _props$duration,
      wrapperRef = props.wrapperRef,
      rest = _objectWithoutProperties(props, ["onClose", "options", "space", "Component", "position", "duration", "wrapperRef"]);

  useTimeout(duration * 1000, onClose);

  var wrapperClassName = options.wrapperClassName,
      restOptions = _objectWithoutProperties(options, ["wrapperClassName"]);

  return React.createElement("div", Object.assign({}, rest, {
    className: wrapperClassName,
    ref: wrapperRef,
    style: _objectSpread({
      textAlign: position.horizontal === 'dock' ? undefined : position.horizontal,
      pointerEvents: 'none',
      marginBottom: space
    }, rest.style)
  }), React.createElement(Component, Object.assign({}, restOptions, {
    onClose: onClose
  })));
}